<template>
  <v-row justify="center" align="center" v-if="ConversationSubjects">
    <v-col cols="12">
      <v-row justify="center" align="center" id="ConversationSubjects_graphs">
        <v-col lg="4" cols="12" sm="6" md="6">
          <v-select
            v-model="selected_year"
            :items="select_options"
            :menu-props="{ maxHeight: '400', bottom: true, offsetY: true }"
            :label="
              $t(
                'analytics.conversations.conversations_subjects_split.graph_elements.select.label'
              )
            "
            :hint="
              $t(
                'analytics.conversations.conversations_subjects_split.graph_elements.select.hint'
              )
            "
            persistent-hint
            @change="Onchange"
            clearable
            :disabled="!Object.keys(ConversationSubjects).length"
          ></v-select>
        </v-col>
        <v-col
          lg="9"
          cols="12"
          sm="12"
          md="12"
          v-if="selected_year === undefined && !loading"
        >
          <div class="text-center">
            <v-overlay
              color="rgba(238,238,238,0.93)"
              style="
                z-index: 4;
                position: absolute;
                min-height: 100%;
                top: -19px;
                border-radius: 5px;
              "
              opacity=".8"
              v-if="!Object.keys(ConversationSubjects).length"
            >
              <h1 class="black--text">
                {{
                  $t(
                    "analytics.conversations.conversations_subjects_split.graph_elements.no_conversation_subjects"
                  )
                }}
              </h1>
            </v-overlay>
            <MixedCarts :dataSource="dataSource" />
          </div>
        </v-col>
        <v-col cols="12" v-if="selected_year !== undefined && !loading">
          <v-row justify="center" align="center" dense>
            <v-col cols="12" lg="6">
              <v-card elevation="0" outlined max-width="400" class="mx-auto">
                <v-card-title>
                  {{
                    $t(
                      "analytics.conversations.conversations_subjects_split.graph_elements.select.users_list.title"
                    )
                  }}
                  :
                </v-card-title>
                <v-virtual-scroll
                  :items="ConversationSubjects[this.selected_year].receiver_ids"
                  max-height="300"
                  item-height="64"
                >
                  <template v-slot:default="{ item }">
                    <v-list-item :key="item">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{
                            $t(
                              "analytics.conversations.conversations_subjects_split.graph_elements.select.users_list.elements"
                            )
                          }}
                          <strong>ID {{ item }}</strong>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                    <v-divider></v-divider>
                  </template>
                </v-virtual-scroll>
              </v-card>
            </v-col>
            <v-col cols="12" lg="6">
              <MixedCarts :dataSource="dataSource1" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import MixedCarts from "../charts/ApexCartsMixed.vue";
export default {
  name: "concersation_subjects",
  components: {
    MixedCarts,
  },
  data() {
    return {
      selected_year: undefined,
      select_options: [],
      monthNames: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      loading: false,
      dataSource: {
        height: 350,
        type: "bar",
        series: [
          {
            name: "Number of conversation with subjects",
            type: "column",
            data: [],
          },
        ],
        chartOptions: {
          colors: ["#E91E63"],
          chart: {
            height: 350,
            type: "bar",
          },
          stroke: {
            show: true,
            curve: "smooth",
            lineCap: "butt",
            colors: undefined,
            width: 2,
            dashArray: 0,
          },
          dataLabels: {
            enabled: true,
          },
          labels: [],
          legend: {
            show: true,
            showForSingleSeries: true,
            showForNullSeries: true,
            showForZeroSeries: true,
            position: "bottom",
            horizontalAlign: "center",
            floating: false,
            fontSize: "14px",
          },
          xaxis: {
            type: "date",
          },
          yaxis: [
            {
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: "#E91E63",
              },
              labels: {
                style: {
                  colors: "#E91E63",
                },
                formatter: function (val) {
                  return val;
                },
              },
              title: {
                text: "Conversations Number",
                style: {
                  color: "black",
                },
              },
              tooltip: {
                enabled: true,
              },
            },
          ],
        },
      },
      dataSource1: {
        height: 350,
        type: "donut",
        series: [],
        chart: {
          width: 380,
          type: "donut",
          dropShadow: {
            enabled: true,
            color: "#111",
            top: -1,
            left: 3,
            blur: 3,
            opacity: 0.2,
          },
        },
        chartOptions: {
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  total: {
                    showAlways: false,
                    show: true,
                  },
                },
              },
            },
          },
          colors: [
            "#A5978B",
            "#2b908f",
            "#f9a3a4",
            "#90ee7e",
            "#f48024",
            "#69d2e7",
            "#33b2df",
            "#546E7A",
            "#d4526e",
            "#13d8aa",
          ],
          labels: [],
          dataLabels: {
            enabled: true,
            dropShadow: {
              blur: 2,
              opacity: 0.8,
            },
            formatter: function (val) {
              return val.toFixed(0) + "%";
            },
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {},
                legend: {
                  show: false,
                },
              },
            },
          ],
          legend: {
            position: "left",
            offsetX: 10,
            offsetY: 0,
            height: 230,
            formatter: function (seriesName, opts) {
              return [
                seriesName,
                " - ",
                "(" + opts.w.globals.series[opts.seriesIndex] + ")",
              ];
            },
          },
        },
      },
    };
  },
  computed: {
    ConversationSubjects() {
      const data = this.$store.state.analytics.ConversationSubjects;
      console.log("concersation_subjects computed : ", data);
      return data;
    },
  },
  async created() {
    if (this.ConversationSubjects) {
      this.loading = true;
      await this.init_vals().then((r) => {
        this.dataSource.chartOptions.labels = r.labels;
        this.select_options = r.select_options;
        this.dataSource.series[0].data = r.data;
        this.dataSource.series[0].name = this.$t(
          "analytics.conversations.conversations_subjects_split.graph_elements.conversation_number"
        );
      });
      this.loading = false;
    }
  },
  methods: {
    async init_vals() {
      try {
        const res = {
          data: [],
          labels: [],
          select_options: [],
        };
        if (this.ConversationSubjects) {
          for (const [key, value] of Object.entries(
            this.ConversationSubjects
          )) {
            const split = key.split("-");
            res.labels.push(`${this.monthNames[split[1] - 1]} - ${split[0]}`);
            res.select_options.push({
              text: `${this.monthNames[split[1] - 1]} - ${split[0]}`,
              value: key,
            });
            res.data.push(value.count);
          }
          return res;
        }
      } catch {
        return undefined;
      }
    },
    async Onchange() {
      this.dataSource1.series = [];
      this.dataSource1.chartOptions.labels = [];
      this.loading = true;
      await this.set_vals()
        .then((r) => {
          console.log(r);
          if (r) {
            this.dataSource1.chartOptions.labels = r.labels;
            this.dataSource1.series = r.series;
          }
          this.loading = false;
          this.scrollToElement();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async set_vals() {
      try {
        let res = {
          labels: [],
          series: [],
        };
        if (this.selected_year !== undefined) {
          let data = this.ConversationSubjects[this.selected_year]
            .conversation_subjects;
          for (const [key, value] of Object.entries(data)) {
            res.labels.push(key);
            res.series.push(value);
          }
          return res;
        }
      } catch {
        return undefined;
      }
    },
    scrollToElement() {
      this.$vuetify.goTo("#ConversationSubjects_graphs", {
        duration: 1300,
        offset: 200,
        easing: "easeInOutCubic",
      });
    },
  },
};
</script>
